// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__3w7V8","loader":"Loader_loader__2hZcM"};